module.exports = __webpack_public_path__ + "static/img/ribbon.2705a858.png";